<script setup lang="ts">
import {PurchaseOperationSubtype} from "@enums/PurchaseOperationSubtype";
import {PropType, toRef, UnwrapRef} from "vue";
import PurchaseOperation from "@models/operations/PurchaseOperation";
import {ReactiveBuyingOperation} from "@/services/operations/AbstractBuyingService";

const props = defineProps({
    payment: {
        type: Object as PropType<UnwrapRef<PurchaseOperation>>,
        required: true
    },
});

const payment: ReactiveBuyingOperation = toRef(props, 'payment');
</script>

<template>
    <div class="payment-meta__block" v-if="payment && payment.subtype">
        <p class="payment-meta__text">{{ $t('g.operation.meta.sum') }}</p>
        <p v-if="[PurchaseOperationSubtype.default, PurchaseOperationSubtype.lite].includes(payment.subtype)"
           class="payment-meta__text" v-format-number>{{ payment.amountUsd }} $</p>
        <p v-else class="payment-meta__text" v-format-number>{{ payment.amountFromWallet }} $</p>
    </div>
</template>

<style scoped lang="scss">

</style>
